export const validNumber = new RegExp(
    /^[0-9]*$/
)

export const validPhone = new RegExp(
    /^[0-9\-\+]{9,15}$/
)